import confettiUrl from '../assets/images/confetti.svg?url';
import outsideTapTargetUrl from '../assets/images/outside-tap-target.svg?url';

import type { TracingGameData } from '../types';

export const TRACING_GAME_TEXTURE_KEYS = {
	confetti: 'tracing-confetti',
	outsideTapTarget: 'tracing-outside-tap-target',
	confettiColors: 'tracing-confetti-colors',
	background: 'tracing-background',
	goal: 'tracing-goal',
	pathFollower: 'tracing-path-follower',
	strokeElement: 'tracing-stroke-element',
	rewardElement: 'tracing-reward-element',
	rewardElementBackground: 'tracing-reward-element-background',
	victory: 'tracing-victory',
} as const;

export const TRACING_GAME_CONFETTI_URL = confettiUrl;
export const TRACING_GAME_OUTSIDE_TAP_TARGET_URL = outsideTapTargetUrl;

export const getTracingGameDecorationTextureKey = (index: number) => `tracing-decoration-${index}`;

export const getTracingGameDataTextures = (presentation: TracingGameData['presentation']) => [
	{ url: presentation.background_image_url, textureKey: TRACING_GAME_TEXTURE_KEYS.background },
	{ url: presentation.goal?.image_url, textureKey: TRACING_GAME_TEXTURE_KEYS.goal },
	{
		url: presentation.path_follower?.image_url,
		textureKey: TRACING_GAME_TEXTURE_KEYS.pathFollower,
	},
	{
		url: presentation.stroke?.element_image_url,
		textureKey: TRACING_GAME_TEXTURE_KEYS.strokeElement,
	},
	{
		url: presentation.stroke?.reward_element_image_url,
		textureKey: TRACING_GAME_TEXTURE_KEYS.rewardElement,
	},
	{
		url: presentation.stroke?.reward_element_background_url,
		textureKey: TRACING_GAME_TEXTURE_KEYS.rewardElementBackground,
	},
	{ url: presentation.goal?.victory_image_url, textureKey: TRACING_GAME_TEXTURE_KEYS.victory },
	...(presentation.decorations ?? []).map(({ decoration_url }, index) => ({
		url: decoration_url,
		textureKey: getTracingGameDecorationTextureKey(index),
	})),
];
